import { render, staticRenderFns } from "./AddCollCustomer.vue?vue&type=template&id=a70b74ce&scoped=true"
import script from "./AddCollCustomer.vue?vue&type=script&lang=js"
export * from "./AddCollCustomer.vue?vue&type=script&lang=js"
import style0 from "./AddCollCustomer.vue?vue&type=style&index=0&id=a70b74ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70b74ce",
  null
  
)

export default component.exports